import React from "react";
import styled from "styled-components";
import BookItem from "../library/BookItem";

const WrapperStyled = styled.div``;

const BookItemV2 = ({ langData, item, lang, getItemAnimation, bookPreviewHandle, config, isLastSeen }) => {
    return (
        <WrapperStyled>
            <BookItem
                isLastSeen={isLastSeen}
                config={config}
                lang={lang}
                langData={langData}
                key={item._id}
                item={item}
                selecteBook={(book) => bookPreviewHandle(book)}
            />
        </WrapperStyled>
    );
};

export default BookItemV2;
